var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 82,
    viewBox: "0 0 100 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19089",
    "data-name": "Rectangle 19089",
    width: 100,
    height: 82,
    transform: "translate(0.103 0.354)",
    fill: "#94a5af"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48327",
    "data-name": "Group 48327",
    transform: "translate(0.311 -0.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35732",
    "data-name": "Group 35732",
    transform: "translate(-0.413 0.156)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35941",
    "data-name": "Path 35941",
    d: "M0,73.871V42.988c.063-.112.136-.22.188-.336Q8.263,24.7,16.329,6.751A10.535,10.535,0,0,1,26.773,0Q49.689.05,72.6,0c5.027-.013,8.475,2.22,10.518,6.787Q89.4,20.815,95.733,34.815c1.206,2.672,2.466,5.32,3.7,7.978V73.871a21.757,21.757,0,0,1-.922,2.828c-2.007,4.188-5.388,6.164-10.017,6.161q-38.777-.021-77.553-.008c-.356,0-.712-.007-1.067-.023A10.169,10.169,0,0,1,2.831,79.6,11.663,11.663,0,0,1,0,73.871M5.276,41.434c4.121,0,8.067,0,12.013,0a6.308,6.308,0,0,1,6.574,4.548q1.924,5.128,3.846,10.257a2.172,2.172,0,0,0,2.541,1.75q19.469,0,38.938,0a2.17,2.17,0,0,0,2.535-1.758c1.323-3.507,2.629-7.02,3.962-10.524a6.2,6.2,0,0,1,6.174-4.272c3.722-.006,7.444,0,11.167,0,.335,0,.669-.028,1.075-.046-.153-.381-.251-.651-.369-.912Q86.491,24.383,79.254,8.289A6.49,6.49,0,0,0,72.776,4.13q-23.062.037-46.123,0a6.482,6.482,0,0,0-6.474,4.164Q14.187,21.7,8.136,35.089c-.926,2.058-1.855,4.115-2.86,6.345M4.127,45.561v1.019q0,12.718,0,25.435c0,4.123,2.614,6.709,6.749,6.71q38.828,0,77.656,0c4.188,0,6.768-2.581,6.771-6.787q.01-12.62,0-25.241V45.61c-.448-.02-.764-.046-1.08-.047q-6.018,0-12.036,0c-1.646,0-2.172.371-2.748,1.906-1.293,3.448-2.578,6.9-3.879,10.344a6.245,6.245,0,0,1-6.228,4.35q-19.608.016-39.216,0a6.237,6.237,0,0,1-6.239-4.333q-1.939-5.12-3.853-10.25c-.642-1.71-1.094-2.019-2.958-2.02H4.127Z",
    transform: "translate(0.328 -0.124)",
    fill: "#94a5af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.acd56bf34a19fdf0034aec9dd6cb0662.svg";
export { ForwardRef as ReactComponent };